export enum BuyBoxModals {
  ADD_TO_ECHAIN,
  SHOW_COPPER_CALCULATOR,
  ADD_CFCASE_CONFIGURATION_TO_SHOPPING_CART,
  SHOW_ESKIN_NOTIFICATION_BEFORE_SHOPPING_CART,
  ADD_TO_SHOPPING_CART,
  ADD_TO_MYIGUS_WISH_LIST,
  SHOW_PARTS_LIST,
  FILE_CREATION,
}
